
import { DotOutlineIcon } from "@phosphor-icons/react"; 
import { IconType } from "react-icons";
import { Link as RouterLink, useLocation } from "react-router-dom";

interface SubItemMenuProps {
  title: string;
  to: string;
  hasDivider?: boolean;
  fullTitle?: string;
  id: number;
  icon?: IconType | React.ForwardRefExoticComponent<any>;
}

export function SubItemMenu({
  title,
  to,
  hasDivider,
  icon: IconComponent = DotOutlineIcon as any,
}: SubItemMenuProps) {
  const { pathname } = useLocation();
  const isActive = pathname.includes(to);

  return (
    <div className="transition-all duration-200 ease-out animate-fade-in">
      {hasDivider && <div className=" border border-blue-base-disabled mb-1" />}

      <RouterLink
        to={to}
        className={`
          group flex items-center whitespace-nowrap  px-2 rounded-title h-[30px] transition-all duration-200 ease-out text-sm
          hover:no-underline hover:bg-surface-hover
          active:translate-x-0 active:bg-surface-hover/80
          focus-visible:shadow-focus focus-visible:outline-none
          ${
            isActive
              ? "bg-surface-hover text-text-primary shadow-hover"
              : "text-text-inverted hover:text-text-primary"
          }
        `}
        aria-current={isActive ? "page" : undefined}
      >
        <IconComponent
          className={`
            mr-2 text-base shrink-0 transition-colors duration-200
            ${
              isActive
                ? "text-text-primary"
                : "text-text-inverted group-hover:text-text-primary"
            }
          `}
        />
        <span className="text-sm">{title} </span>
      </RouterLink>
    </div>
  );
}
